import React from 'react';
import Modal from './modal';

export default function PrivacyModal({ onClose }) {
  return (
    <Modal title="Privacy Policy" onClose={onClose}>
      <h3>1. Introduction</h3>
      <p>London Casino Deals ("we", "our", "us") is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect your data when you visit londoncasinodeals.com.</p>

      <h3>2. Information We Collect</h3>
      <p>We may collect the following data:</p>
      <ul>
        <li>Usage data (pages visited, time on site, browser type, IP address)</li>
        <li>Cookie data (see our Cookie Policy)</li>
        <li>Any information you voluntarily submit via contact forms</li>
      </ul>

      <h3>3. How We Use Your Data</h3>
      <p>We use collected data to improve site performance, analyse traffic patterns, and ensure compliance with applicable regulations. We do not sell your data to third parties.</p>

      <h3>4. Third-Party Links</h3>
      <p>Our site contains affiliate links to third-party casino operators. We are not responsible for the privacy practices of those external sites. We encourage you to review their respective privacy policies.</p>

      <h3>5. Cookies</h3>
      <p>We use cookies to enhance your browsing experience. You can manage cookie preferences through your browser settings or our cookie consent tool.</p>

      <h3>6. Your Rights</h3>
      <p>Under UK GDPR, you have the right to access, rectify, erase, or restrict the processing of your personal data. To exercise these rights, contact us at info@londoncasinodeals.com.</p>

      <h3>7. Data Retention</h3>
      <p>We retain analytics data for up to 26 months. Data submitted via contact forms is deleted after your query is resolved.</p>

      <h3>8. Contact</h3>
      <p>For privacy-related enquiries, email: info@londoncasinodeals.com</p>

      <p style={{ marginTop: 20, fontSize: '0.78rem', color: '#8fa3c4' }}>Last updated: April 2026</p>
    </Modal>
  );
}
